import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "",
  style: {"overflow":"auto"}
}
const _hoisted_2 = {
  class: "table table-striped",
  style: {"position":"relative"}
}
const _hoisted_3 = { class: "text-start p-sm" }
const _hoisted_4 = { class: "text-capitalize-first" }
const _hoisted_5 = { class: "text-start p-sm" }
const _hoisted_6 = { class: "text-capitalize-first" }
const _hoisted_7 = { class: "text-start p-sm" }
const _hoisted_8 = { class: "text-capitalize-first" }
const _hoisted_9 = { class: "text-start p-sm" }
const _hoisted_10 = { class: "text-capitalize-first" }
const _hoisted_11 = { class: "p-sm" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = {
  key: 0,
  class: "p-sm"
}
const _hoisted_14 = ["onUpdate:modelValue"]
const _hoisted_15 = {
  key: 1,
  class: "p-sm"
}
const _hoisted_16 = {
  key: 2,
  class: "p-sm"
}
const _hoisted_17 = { class: "p-sm" }
const _hoisted_18 = { class: "p-sm" }
const _hoisted_19 = { class: "text-end p-sm" }
const _hoisted_20 = {
  key: 0,
  class: "d-flex justify-content-end align-items-center gap-sm"
}
const _hoisted_21 = ["onClick"]
const _hoisted_22 = {
  key: 1,
  class: "d-flex justify-content-end align-items-center gap-sm"
}
const _hoisted_23 = ["onClick"]
const _hoisted_24 = {
  colspan: "5",
  class: "text-center"
}
const _hoisted_25 = { class: "text-capitalize-first" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoaderButton = _resolveComponent("LoaderButton")!
  const _component_LoaderContent = _resolveComponent("LoaderContent")!
  const _component_Popup = _resolveComponent("Popup")!
  const _component_RequisitesGroupEditPopup = _resolveComponent("RequisitesGroupEditPopup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Popup, {
      ref: (el) => _ctx.popup = el,
      class: "",
      title: _ctx.$t('button.groups'),
      onOnClose: _ctx.hide
    }, {
      default: _withCtx(() => [
        _createVNode(_component_LoaderContent, {
          ref: "loader",
          class: ""
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("table", _hoisted_2, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", _hoisted_3, [
                      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.helper.trans('labels.id')), 1)
                    ]),
                    _createElementVNode("th", _hoisted_5, [
                      _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.helper.trans('labels.name')), 1)
                    ]),
                    _createElementVNode("th", _hoisted_7, [
                      _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.helper.trans('labels.req_count')), 1)
                    ]),
                    _createElementVNode("th", _hoisted_9, [
                      _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.helper.trans('labels.active_req_count')), 1)
                    ]),
                    _cache[2] || (_cache[2] = _createElementVNode("th", null, null, -1))
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groups, (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: index,
                      class: ""
                    }, [
                      _createElementVNode("td", _hoisted_11, [
                        (item.id)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(item.id), 1))
                          : _createCommentVNode("", true)
                      ]),
                      (!item.id)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_13, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              "onUpdate:modelValue": ($event: any) => ((item.name) = $event),
                              class: "form-control",
                              style: {"min-width":"100px"}
                            }, null, 8, _hoisted_14), [
                              [_vModelText, item.name]
                            ])
                          ]))
                        : (_ctx.currentEditGroup && _ctx.currentEditGroup.id === item.id)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_15, [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentEditGroup.name) = $event)),
                                class: "form-control",
                                style: {"min-width":"100px"}
                              }, null, 512), [
                                [_vModelText, _ctx.currentEditGroup.name]
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("td", _hoisted_16, _toDisplayString(item.name), 1)),
                      _createElementVNode("td", _hoisted_17, _toDisplayString(item.requisitesCount), 1),
                      _createElementVNode("td", _hoisted_18, _toDisplayString(item.activeRequisitesCount), 1),
                      _createElementVNode("td", _hoisted_19, [
                        (!item.id || _ctx.currentEditGroup && _ctx.currentEditGroup.id === item.id)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                              _createVNode(_component_LoaderButton, {
                                type: "button",
                                "on-click": () => (_ctx.save(index)),
                                class: "btn detail__btn"
                              }, {
                                default: _withCtx(() => _cache[3] || (_cache[3] = [
                                  _createElementVNode("svg", {
                                    width: "20",
                                    height: "21",
                                    viewBox: "0 0 20 21",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg"
                                  }, [
                                    _createElementVNode("path", {
                                      d: "M15.2044 7.14856L8.74285 14.8409C8.67197 14.9253 8.58377 14.9935 8.48423 15.0409C8.3847 15.0882 8.27614 15.1136 8.16592 15.1154H8.15294C8.04512 15.1154 7.93852 15.0926 7.84004 15.0488C7.74156 15.0049 7.65341 14.9407 7.58131 14.8606L4.81208 11.7837C4.74175 11.7091 4.68704 11.6212 4.65117 11.5251C4.61529 11.4291 4.59898 11.3269 4.60319 11.2244C4.60739 11.122 4.63203 11.0214 4.67565 10.9287C4.71927 10.8359 4.781 10.7528 4.85721 10.6842C4.93341 10.6156 5.02256 10.5629 5.1194 10.5293C5.21625 10.4957 5.31884 10.4817 5.42115 10.4883C5.52346 10.4949 5.62342 10.5219 5.71515 10.5676C5.80689 10.6134 5.88856 10.677 5.95535 10.7548L8.13275 13.174L14.0265 6.15914C14.1587 6.0063 14.3457 5.91161 14.5472 5.89556C14.7486 5.87951 14.9483 5.94337 15.1031 6.07336C15.2578 6.20334 15.3552 6.38899 15.3741 6.59019C15.3931 6.79139 15.3321 6.99196 15.2044 7.14856Z",
                                      fill: "#F7F9FC"
                                    })
                                  ], -1)
                                ])),
                                _: 2,
                                __: [3]
                              }, 1032, ["on-click"]),
                              _createElementVNode("button", {
                                type: "button",
                                onClick: ($event: any) => (_ctx.cancel(index)),
                                class: "btn detail__btn"
                              }, _cache[4] || (_cache[4] = [
                                _createElementVNode("svg", {
                                  width: "20",
                                  height: "21",
                                  viewBox: "0 0 20 21",
                                  fill: "none",
                                  xmlns: "http://www.w3.org/2000/svg"
                                }, [
                                  _createElementVNode("path", {
                                    "fill-rule": "evenodd",
                                    "clip-rule": "evenodd",
                                    d: "M5.96496 5.40402L15.096 14.535C16.0855 13.2853 16.5814 11.7156 16.4893 10.1242C16.3972 8.53283 15.7235 7.03078 14.5964 5.90362C13.4692 4.77646 11.9672 4.10279 10.3758 4.01068C8.78439 3.91856 7.21464 4.41444 5.96496 5.40402ZM14.035 15.596L4.90396 6.46502C3.91438 7.7147 3.4185 9.28445 3.51062 10.8758C3.60273 12.4672 4.2764 13.9693 5.40356 15.0964C6.53072 16.2236 8.03277 16.8973 9.62415 16.9894C11.2155 17.0815 12.7853 16.5856 14.035 15.596ZM4.34296 4.84302C5.08585 4.10014 5.96779 3.51084 6.93842 3.1088C7.90905 2.70675 8.94936 2.49982 9.99996 2.49982C11.0506 2.49982 12.0909 2.70675 13.0615 3.1088C14.0321 3.51084 14.9141 4.10014 15.657 4.84302C16.3998 5.58591 16.9891 6.46785 17.3912 7.43848C17.7932 8.40911 18.0002 9.44942 18.0002 10.5C18.0002 11.5506 17.7932 12.5909 17.3912 13.5616C16.9891 14.5322 16.3998 15.4141 15.657 16.157C14.1566 17.6574 12.1217 18.5002 9.99996 18.5002C7.87818 18.5002 5.84329 17.6574 4.34296 16.157C2.84263 14.6567 1.99976 12.6218 1.99976 10.5C1.99976 8.37824 2.84263 6.34335 4.34296 4.84302Z",
                                    fill: "#F7F9FC"
                                  })
                                ], -1)
                              ]), 8, _hoisted_21)
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                              _createElementVNode("button", {
                                type: "button",
                                onClick: ($event: any) => (_ctx.edit(item)),
                                class: "btn detail__btn detail__redact"
                              }, _cache[5] || (_cache[5] = [
                                _createElementVNode("svg", {
                                  width: "20",
                                  height: "20",
                                  viewBox: "0 0 20 20",
                                  fill: "none",
                                  xmlns: "http://www.w3.org/2000/svg"
                                }, [
                                  _createElementVNode("path", {
                                    d: "M1.43302 17.9172L2.69502 14.7622C2.89605 14.2592 3.19714 13.8023 3.58002 13.4192L13.9898 3.01046L16.9903 6.01046L6.58102 16.4192C6.19799 16.8025 5.74108 17.1039 5.23802 17.3052L2.08302 18.5672C1.99216 18.6036 1.89262 18.6125 1.79674 18.5928C1.70087 18.5731 1.61287 18.5258 1.54366 18.4566C1.47446 18.3874 1.42708 18.2994 1.40742 18.2035C1.38775 18.1076 1.39665 18.0081 1.43302 17.9172Z",
                                    fill: "#F7F9FC"
                                  }),
                                  _createElementVNode("path", {
                                    d: "M18.1213 4.0012C18.1213 4.56381 17.8978 5.10338 17.5 5.5012L14.5 2.5012C14.8978 2.10338 15.4374 1.87988 16 1.87988C16.5626 1.87988 17.1022 2.10338 17.5 2.5012C17.8978 2.89903 18.1213 3.43859 18.1213 4.0012Z",
                                    fill: "#F7F9FC"
                                  })
                                ], -1)
                              ]), 8, _hoisted_23),
                              _createVNode(_component_LoaderButton, {
                                type: "button",
                                "on-click": () => (_ctx.remove(item)),
                                class: "btn detail__btn detail__remove"
                              }, {
                                default: _withCtx(() => _cache[6] || (_cache[6] = [
                                  _createElementVNode("svg", {
                                    width: "20",
                                    height: "20",
                                    viewBox: "0 0 20 20",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg"
                                  }, [
                                    _createElementVNode("path", {
                                      d: "M2 3C1.73478 3 1.48043 3.10536 1.29289 3.29289C1.10536 3.48043 1 3.73478 1 4V5C1 5.26522 1.10536 5.51957 1.29289 5.70711C1.48043 5.89464 1.73478 6 2 6H18C18.2652 6 18.5196 5.89464 18.7071 5.70711C18.8946 5.51957 19 5.26522 19 5V4C19 3.73478 18.8946 3.48043 18.7071 3.29289C18.5196 3.10536 18.2652 3 18 3H2Z",
                                      fill: "#F7F9FC"
                                    }),
                                    _createElementVNode("path", {
                                      "fill-rule": "evenodd",
                                      "clip-rule": "evenodd",
                                      d: "M2 7.5H18L17.189 15.21C17.1371 15.7015 16.905 16.1564 16.5376 16.487C16.1701 16.8175 15.6933 17.0003 15.199 17H4.802C4.30774 17.0003 3.8309 16.8175 3.46343 16.487C3.09596 16.1564 2.8639 15.7015 2.812 15.21L2 7.5ZM7.22 9.22C7.36063 9.07955 7.55125 9.00066 7.75 9.00066C7.94875 9.00066 8.13937 9.07955 8.28 9.22L10 10.94L11.72 9.22C11.7887 9.14631 11.8715 9.08721 11.9635 9.04622C12.0555 9.00523 12.1548 8.98318 12.2555 8.98141C12.3562 8.97963 12.4562 8.99816 12.5496 9.03588C12.643 9.0736 12.7278 9.12974 12.799 9.20096C12.8703 9.27218 12.9264 9.35701 12.9641 9.4504C13.0018 9.54379 13.0204 9.64382 13.0186 9.74452C13.0168 9.84522 12.9948 9.94454 12.9538 10.0365C12.9128 10.1285 12.8537 10.2113 12.78 10.28L11.06 12L12.78 13.72C12.8537 13.7887 12.9128 13.8715 12.9538 13.9635C12.9948 14.0555 13.0168 14.1548 13.0186 14.2555C13.0204 14.3562 13.0018 14.4562 12.9641 14.5496C12.9264 14.643 12.8703 14.7278 12.799 14.799C12.7278 14.8703 12.643 14.9264 12.5496 14.9641C12.4562 15.0018 12.3562 15.0204 12.2555 15.0186C12.1548 15.0168 12.0555 14.9948 11.9635 14.9538C11.8715 14.9128 11.7887 14.8537 11.72 14.78L10 13.06L8.28 14.78C8.13783 14.9125 7.94978 14.9846 7.75548 14.9812C7.56118 14.9777 7.37579 14.899 7.23838 14.7616C7.10097 14.6242 7.02225 14.4388 7.01883 14.2445C7.0154 14.0502 7.08752 13.8622 7.22 13.72L8.94 12L7.22 10.28C7.07955 10.1394 7.00066 9.94875 7.00066 9.75C7.00066 9.55125 7.07955 9.36063 7.22 9.22Z",
                                      fill: "#F7F9FC"
                                    })
                                  ], -1)
                                ])),
                                _: 2,
                                __: [6]
                              }, 1032, ["on-click"])
                            ]))
                      ])
                    ]))
                  }), 128))
                ]),
                _createElementVNode("tfoot", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_24, [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.add())),
                        class: "btn btn-sm btn-outline-dark text-nowrap text-capitalize-first w-100"
                      }, [
                        _cache[7] || (_cache[7] = _createElementVNode("svg", {
                          width: "20",
                          height: "21",
                          viewBox: "0 0 20 21",
                          fill: "none",
                          xmlns: "http://www.w3.org/2000/svg"
                        }, [
                          _createElementVNode("path", {
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d: "M10 18.5C12.1217 18.5 14.1566 17.6571 15.6569 16.1569C17.1571 14.6566 18 12.6217 18 10.5C18 8.37827 17.1571 6.34344 15.6569 4.84315C14.1566 3.34285 12.1217 2.5 10 2.5C7.87827 2.5 5.84344 3.34285 4.34315 4.84315C2.84285 6.34344 2 8.37827 2 10.5C2 12.6217 2.84285 14.6566 4.34315 16.1569C5.84344 17.6571 7.87827 18.5 10 18.5ZM10.75 7.25C10.75 7.05109 10.671 6.86032 10.5303 6.71967C10.3897 6.57902 10.1989 6.5 10 6.5C9.80109 6.5 9.61032 6.57902 9.46967 6.71967C9.32902 6.86032 9.25 7.05109 9.25 7.25V9.75H6.75C6.55109 9.75 6.36032 9.82902 6.21967 9.96967C6.07902 10.1103 6 10.3011 6 10.5C6 10.6989 6.07902 10.8897 6.21967 11.0303C6.36032 11.171 6.55109 11.25 6.75 11.25H9.25V13.75C9.25 13.9489 9.32902 14.1397 9.46967 14.2803C9.61032 14.421 9.80109 14.5 10 14.5C10.1989 14.5 10.3897 14.421 10.5303 14.2803C10.671 14.1397 10.75 13.9489 10.75 13.75V11.25H13.25C13.4489 11.25 13.6397 11.171 13.7803 11.0303C13.921 10.8897 14 10.6989 14 10.5C14 10.3011 13.921 10.1103 13.7803 9.96967C13.6397 9.82902 13.4489 9.75 13.25 9.75H10.75V7.25Z",
                            fill: "#F7F9FC"
                          })
                        ], -1)),
                        _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.helper.trans('button.add')), 1)
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }, 512)
      ]),
      _: 1
    }, 8, ["title", "onOnClose"]),
    _createVNode(_component_RequisitesGroupEditPopup, {
      onUpdated: _ctx.load,
      ref: "requisitesGroupEditPopup"
    }, null, 8, ["onUpdated"])
  ], 64))
}